import React, { useState } from "react";
import axios from "axios";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const ResetPassword = () => {
    const { uid: paramUid, token: paramToken } = useParams();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    // Support both path params and query params for flexibility
    const uid = paramUid || searchParams.get("uid");
    const token = paramToken || searchParams.get("token");
    const [formData, setFormData] = useState({
        new_password: "",
        confirm_password: "",
    });
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.new_password !== formData.confirm_password) {
            alert("Passwords do not match.");
            return;
        }
        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/password-reset/confirm/`, {
                uid: uid,
                token: token,
                new_password: formData.new_password,
                confirm_password: formData.confirm_password
            });
            setIsSuccess(true);
        } catch (err) {
            alert(err.response?.data?.detail || "The reset link is invalid or has expired.");
        }
    };

    if (isSuccess) {
        return (
            <section className="account-wrapper">
                <div className="auth-background">
                    <div className="circle circle-1"></div>
                    <div className="circle circle-2"></div>
                </div>
                <div className="account-content">
                    <div className="container container-sm">
                        <div className="form-card text-center" style={{ padding: '40px' }}>
                            <h4 className="form-title">Success!</h4>
                            <p className="form-subtitle">Your password has been successfully reset.</p>
                            <button
                                className="submit-btn"
                                onClick={() => navigate("/account")}
                                style={{ marginTop: '20px' }}
                            >
                                Back to Login
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="account-wrapper">
            <div className="auth-background">
                <div className="circle circle-1"></div>
                <div className="circle circle-2"></div>
            </div>
            <div className="account-content">
                <div className="container container-sm">
                    <div className="form-card">
                        <div className="form-container">
                            <div className="form-section login-form active">
                                <h4 className="form-title">Set New Password</h4>
                                <p className="form-subtitle">Choose a strong password for your account</p>
                                <form className="auth-form" onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <label className="form-label">New Password</label>
                                        <div className="input-wrapper">
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                className="form-input"
                                                placeholder="Enter new password"
                                                name="new_password"
                                                value={formData.new_password}
                                                onChange={handleChange}
                                                required
                                            />
                                            <span
                                                className="show-password-icon"
                                                onClick={() => setShowPassword((v) => !v)}
                                                style={{ position: "absolute", right: 18, cursor: "pointer", zIndex: 2 }}
                                            >
                                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">Confirm New Password</label>
                                        <div className="input-wrapper">
                                            <input
                                                type={showConfirmPassword ? "text" : "password"}
                                                className="form-input"
                                                placeholder="Confirm new password"
                                                name="confirm_password"
                                                value={formData.confirm_password}
                                                onChange={handleChange}
                                                required
                                            />
                                            <span
                                                className="show-password-icon"
                                                onClick={() => setShowConfirmPassword((v) => !v)}
                                                style={{ position: "absolute", right: 18, cursor: "pointer", zIndex: 2 }}
                                            >
                                                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                            </span>
                                        </div>
                                    </div>
                                    <button type="submit" className="submit-btn" style={{ marginTop: '20px' }}>
                                        Reset Password
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ResetPassword;
